<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col cols="12" md="8" class="text-center text-sm-left mb-0 pr-2">
        <span class="text-uppercase page-subtitle d-block">Projetos</span>
        <h3 class="page-title d-inline">Status</h3>
        <d-button class="btn btn-success text-white float-right" @click.prevent="addNewStatus()">Novo status</d-button>
      </d-col>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col cols="12" md="8">
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Lista</h6>
            </div>
            <div class="col-6">
              <form action="#" class="main-sidebar__search w-100 border-right dß-flex">
              <div class="input-group input-group-seamless ml-3">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="fas fa-search"></i>
                  </div>
                </div>
                <input
                  class="navbar-search form-control"
                  type="text"
                  placeholder="Procurar por algo..."
                  aria-label="Search"
                  v-model="pagination.search"
                >
              </div>
            </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <status-table :statuses="statuses" />
            </div>
          </div>
        </d-card>
      </d-col>
    </d-row>
    <status-modal/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import StatusTable from '_modules/project/components/StatusTable.vue';
import StatusModal from '_modules/project/components/StatusModal.vue';
import { _SELECTED_STATUS_, _SAVE_STATUS_SUCCESS_, MODEL_STATUS } from '_modules/project/components/ProjectModel';

export default {
  name: 'customer-list',
  components: {
    Pagination,
    StatusTable,
    StatusModal,
  },
  data() {
    return {
      pagination: {
        search: '',
      },
    };
  },
  computed: {
    statuses() {
      const { status } = this.$store.state.project;
      if (status && status.length) {
        return status;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getProjectStatus',
    ]),
    getStatus() {
      if (!this.$store.state.project.status) {
        this.getProjectStatus();
      }
      return true;
    },
    addNewStatus() {
      Events.$emit(_SELECTED_STATUS_, MODEL_STATUS);
      this.setToggle({ type: 'status_modal', bool: true });
    },
  },
  mounted() {
    Events.$on(_SAVE_STATUS_SUCCESS_, () => {
      this.getProjectStatus();
    });
    this.getStatus();
  },

};
</script>

<style lang="scss" scoped>
</style>
